export enum KeyErrorEnum {
  ARRAY_VALUE = 'value[]',
  ZIPCODE = 'zipcode',
  PREFECTURE = 'prefecture',
  ADDRESS = 'address',
  TARGET_PRODUCT = 'target_product',
}
